import { h } from 'preact'
import styles from './section.module.css'
import { Text } from './text/text'
import { Image } from './image/image'
import { Video } from './video/video'
import { Timeline } from './timeline/timeline'
import { SideExplainer } from './side-explainer/side-explainer'
import { Map } from './map/map'
import { Spesialmodul } from './spesialmodul/spesialmodul'
import { Header } from './header/header'

export const Section = ({ title, content = [], stickyTitles }) => {
  const mappedContent = content.map((el) => {
    const Component = getComponentForType(el.type)
    return <Component {...el} />
  })

  const titleClasses = [styles.sectionTitle, stickyTitles ? styles.stickyTitle : undefined]
    .filter(Boolean)
    .join(' ')
  return (
    <section className={styles.section}>
      <div className={titleClasses}>
        <h2 id={title}>{title}</h2>
      </div>
      {mappedContent}
    </section>
  )
}

function getComponentForType(type) {
  switch (type) {
    case 'text':
      return Text
    case 'timeline':
      return Timeline
    case 'For og imot':
      return SideExplainer
    case 'header':
      return Header
    case 'image':
      return Image
    case 'video':
      return Video
    case 'map':
      return Map
    case 'spesialmodul':
      return Spesialmodul
    default:
      return Text
  }
}
